import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Header, Table } from "@pentabd/ui";

import { IconCalendarCheck02 } from "@pentabd/icons";

import { SearchBox } from "@components";
import { StockProductListDetailsTableColumn } from "./TableColumn";

import { useProductList } from "@hooks/inventory/stock/productList/useProductList";
import { useLanguage } from "@hooks/useLanguage";

import { ItemsResponseType } from "@type/inventory/stock/items";

import { TablePagination } from "@helpers/tablePagination";

import { ROUTES } from "@constants/routes";

const { INVENTORY } = ROUTES;
const { STOCK } = INVENTORY;

export default function StockProductListDetailsTable() {
  const moduleName = localStorage.getItem("module");

  const { t } = useTranslation();
  const { language } = useLanguage();
  const { control } = useForm();

  const { handleQuery, productsState } = useProductList();
  const { getData } = productsState;

  const { data, pagination, product } = getData || ({} as ItemsResponseType);

  const breadcrumbs = [
    {
      icon: <IconCalendarCheck02 fill="dark" size="20" />,
    },
    {
      link: STOCK,
      label:
        moduleName === "ITS"
          ? t("SIDEBAR.IT_INVENTORY.HARDWARE_INVENTORY")
          : t("SIDEBAR.INVENTORY.STOCK"),
    },
    {
      label: language === "bn" ? product?.nameBn : product?.nameEn,
    },
  ];

  const headerText = {
    header:
      language === "bn"
        ? `${product?.nameBn} (${product?.type})`
        : `${product?.nameEn} (${product?.type})`,
  };

  return (
    <>
      <Header headerText={headerText} breadcrumbs={breadcrumbs} />

      <Table
        header={{
          title: t("INVENTORY_STOCK.PRODUCTS.TABLE.HEADER"),
          badge: {
            label: `${pagination?.total || 0}`,
            size: "sm",
            type: "primary",
          },
        }}
        headerExtension={{
          leftComponents: [],
          rightComponents: [
            <SearchBox
              key="search"
              control={control}
              placeholder={t("INVENTORY_STOCK.ITEMS.TABLE.SEARCH")}
              handleQuery={handleQuery}
            />,
          ],
        }}
        columns={StockProductListDetailsTableColumn(t, language)}
        rows={data || []}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </>
  );
}
